import React, { Component} from 'react';
import { connect } from "react-redux";
import ReactTable from "react-table";
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledTooltip, Card, CardBody, CardHeader } from "reactstrap";
import { NotificationManager } from "react-notifications";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import "react-table/react-table.css";
import Proptypes from "prop-types";
import { Link } from "react-router-dom";
import {getBrandingConfigs, deleteBrandingConfig} from "../../actions/actionBranding"
import moment from "moment";
import { fuzzySearch } from "../../utils/helpers";

class BrandingConfig extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            filterId: null
        };
        this.cancelDelete = this.cancelDelete.bind(this);
        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.deleteBrandingAction = this.deleteBrandingAction.bind(this);
        this.handleDeleteSuccess = this.handleDeleteSuccess.bind(this);
        this.handleDeleteError = this.handleDeleteError.bind(this);
    }

    componentDidMount() {
        this.props.getBrandingConfigs();
    }

    deleteConfirm(brandingConfigId){
        this.setState({modal: !this.state.modal,
            brandingConfigId: brandingConfigId});
    }

    cancelDelete(){
        this.setState({modal: !this.state.modal});
    }

    deleteBrandingAction(){
        this.props.deleteBrandingConfig(this.state.brandingConfigId).
        then(() => this.handleDeleteSuccess()).
        catch(() => this.handleDeleteError());
    }

    handleDeleteSuccess(){
        const {deleteBrandingErrorMessage} = this.props;
        if(deleteBrandingErrorMessage) {
            NotificationManager.error(deleteBrandingErrorMessage,"Delete Branding Config Failed", 3000);
        }else{
            NotificationManager.success("Successfully Deleted Branding Config","Delete Branding Config", 3000);
            this.setState({modal: false});
            this.props.getBrandingConfigs();
        }
    }

    handleDeleteError(){
        const {deleteBrandingError} = this.props;
        if(deleteBrandingError){
            NotificationManager.error(deleteBrandingError,"Failed to Delete Branding Config", 3000);
            this.props.history.push("/branding");
        }else{
            NotificationManager.error("Failed to Delete Branding Config","Delete Branding Config", 3000);
            this.props.history.push("/banding");
        }
    }

    render() {
        if (this.props.getBrandingLoading) {
            return (<div> <LoadingSpinner /></div>);
        }
        const {branding_configs} = this.props;
        const columns = [
            {   Header: "Name",
                accessor: "name",
                filterMethod: fuzzySearch
            },
            {
                Header: "Hostname",
                accessor: "hostname",
                filterMethod: fuzzySearch
            },
            {
                Header: "Default",
                accessor: "is_default",
                filterMethod: fuzzySearch,
                Cell: (data) => (<div> {data.original.is_default ? 'True' : 'False'}</div>)
            },
            {
                Header: "Actions",
                filterable: false,
                sortable: false,
                Cell: (data) => (<div className="action-btn">
                        <Link className="btn btn-success" id={"TooltipComponent"} to={{ pathname: `/viewbranding/${data.original.branding_config_id}` }}>
                            <i className="fa fa-eye"></i></Link>
                        <Link className="btn btn-warning" id={"Tooltipss"} to={{ pathname: `/updatebranding/${data.original.branding_config_id}` }}>
                            <i className="fa fa-pencil"></i> </Link>
                        <button className="btn btn-danger"  id={"Tooltips"} href="#"  onClick={() => this.deleteConfirm(data.original.branding_config_id)}>
                            <i className="fa fa-trash-o"></i> </button>
                        <UncontrolledTooltip placement="right" target={"TooltipComponent"}> View </UncontrolledTooltip>
                        <UncontrolledTooltip placement="right" target={"Tooltipss"}> Edit </UncontrolledTooltip>
                        <UncontrolledTooltip placement="right" target={"Tooltips"}> Delete </UncontrolledTooltip>
                    </div>
                ),
            }];
        return(
            <div className="mt-4">
                <Row>
                    <Col sm={{ size: 10, order: 3, offset: 1 }}>
                        <Card >
                            <CardHeader>
                                <i className="fa fa-align-justify"></i> <strong>Branding Configurations</strong>
                                <Link className="pull-right" to={{ pathname: "/createbranding" }}>
                                    <Button className="pull-right" size="sm" color="dark">
                                        Create New Config
                                    </Button>
                                </Link>
                            </CardHeader>
                            <CardBody>
                                <ReactTable
                                    columns={columns}
                                    data={branding_configs}
                                    defaultSorted={[{id: "name"}]}
                                    filterable
                                    defaultPageSize={10}
                                    className="-striped -highlight site_table"
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Modal isOpen={this.state.modal} toggle={this.cancelDelete} className={this.props.className}>
                    <ModalHeader toggle={this.cancelDelete}>Delete Branding Config <i className="fa fa-bomb" aria-hidden="true"></i>
                    </ModalHeader>
                    <ModalBody>
                        Confirm Delete Branding Config?
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.deleteBrandingAction} size="sm" color="danger"> <i className="fa fa-trash"></i> Delete</Button>
                        <Button onClick={this.cancelDelete} size="sm" color=" basic"><i className="fa fa-ban"></i> Close</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

}

export default connect(state => ({
        branding_configs: state.branding.branding_configs || [],
        getBrandingLoading: state.branding.getBrandingLoading || false,
        getBrandingErrorMessage: state.branding.getBrandingErrorMessage || false,
        getBrandingError: state.branding.getBrandingError || null,
        deleteBrandingErrorMessage: state.branding.deleteBrandingErrorMessage || null,
        deleteBrandingError: state.branding.deleteBrandingError || null,
        deletedBranding: state.branding.deletedBranding || null,
        deleteBrandingLoading: state.branding.deleteBrandingLoading || null,
    }),
    dispatch => ({
        getBrandingConfigs: () => dispatch(getBrandingConfigs()),
        deleteBrandingConfig: (data) => dispatch(deleteBrandingConfig(data))
    }))(BrandingConfig);



// WEBPACK FOOTER //
// ./src/views/Branding/Branding.js